/** Surface friendly messages from JSON API errors (e.g. segregation of duties). */
export function apiErrorMessage(err, fallback = "Request failed") {
  const msg = err?.message || ""
  if (msg.includes("cannot approve") || msg.includes("segregation")) return msg
  return msg || fallback
}
